<div class="placeholder-container">
  <img class="icon" [src]="imageSrc" alt="" />
  <h3 class="title">{{ title }}</h3>
  <p class="sub-title">{{ subtitle }}</p>
</div>
